import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import store from './store'
import router from './router'
import dictaVueComponents from 'dicta-vue-components'
import VueCookies from 'vue-cookies'
import VueHotkey from 'v-hotkey'

Vue.config.productionTip = false
Vue.use(dictaVueComponents, { hebrew: true, useBodyClass: true })
Vue.use(router)
Vue.use(VueCookies)
Vue.use(VueHotkey)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
